<template>
    <div id="printReport">
        <div class="container">
            <div class="col-sm-2">
                <img src="@/assets/template/images/logo.png" alt="Consyst" style="height: 60px" />
            </div>
            <div class="col-sm-8">
                <h3 class="text-center">Relatório de Tipos de Venda por Perfil</h3>
            </div>
            <div class="col-sm-2"></div>
        </div>
        <br />

        <div class="row" id="conteudo">
            <div class="col-sm-12">
                <div class="panel panel-defaul">
                    <div class="panel-body">
                        <div class="row" id="dados">
                            <div class="col-md-6">
                                <label>Perfil</label>
                                <br />
                                {{ !form.type_profile_id ? 'TODAS' : (profiles.length > 0?profiles.find(profile => profile.id === form.type_profile_id).name.toUpperCase(): 'TODAS') }}
                            </div>
                            <div class="col-md-6">
                                <label>{{ !form.type_profile_id ? 'TODAS' : (profiles.length > 0?profiles.find(profile => profile.id === form.type_profile_id).name.toUpperCase(): 'TODAS') }}</label>
                                <br />
                                {{ form.user_id == undefined || form.user_id.id == undefined ? 'TODOS' : (users.length > 0?users.find(user => user.id === form.user_id.id).name.toUpperCase(): 'TODOS') }}
                            </div>
                        </div>
                        <div class="row" id="dados">
                            <div class="col-md-6">
                                <label>Filtrar por</label>
                                <br />
                                {{ date_by }}
                            </div>
                            <div class="col-md-6">
                                <label>Intervalo</label>
                                <br />
                                <div >{{ form.date_at.length ? moment(form.date_at[0]).format('DD/MM/YYYY') : 'Todas' }} à {{ form.date_at.length ? moment(form.date_at[1]).format('DD/MM/YYYY') : 'Todas' }}</div>
                            </div>
                        </div>
                        <div class="row" id="dados">
                            <div class="col-md-6">
                                <label>Loja</label>
                                <br />
                                {{ !form.branch_id ? 'TODAS' : store_branch}}
                            </div>
                            <div class="col-md-6">
                                <label>Administradora</label>
                                <br />
                                {{ !form.administrator_id ? 'TODAS' : (administrators.length > 0?administrators.find(administrator => administrator.id === form.administrator_id).name.toUpperCase(): 'TODAS') }}
                            </div>
                        </div>
                        <br />
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div class="row" v-for="(items, administratorName) in reportItems" :key="administratorName">
            <div class="col-md-12">
                <div class="panel panel-danger">
                    <div class="panel-body">
                        <b>Administratora: {{ administratorName }}</b>
                        <div class="row" v-for="(proposals, itemName) in items" :key="itemName">
                            <div class="col-md-12">
                                <div class="panel panel-defaul">
                                    <div class="panel-body" style="overflow-x: auto;">
                                        <b>{{ itemName }}</b>
                                        <table id="tabela" class="table b-table table-sm">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th class="text-center">Cliente</th>
                                                    <th class="text-center">N. Contrato</th>
                                                    <th class="text-center">Grupo</th>
                                                    <th class="text-center">Cota</th>
                                                    <th class="text-center">Valor da Cota</th>
                                                    <th class="text-center">Data da Venda</th>
                                                    <th class="text-center">Tipo da Venda</th>
                                                    <th class="text-center">Comissão</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="proposal in proposals.filter(proposal => proposal.totalCommission > 0)" :key="proposal.id">
                                                    <td>{{ proposal.client_name }}</td>
                                                    <td class="text-center">{{ proposal.physical_proposal }}</td>
                                                    <td class="text-center">{{ proposal.group_name ? proposal.group_name : '-' }}</td>
                                                    <td class="text-center">{{ proposal.quota ? proposal.quota : '-' }}</td>
                                                    <td class="text-center">R${{ proposal.value | price }}</td>
                                                    <td class="text-center">{{ proposal.sale_at | moment('DD/MM/YYYY') }}</td>
                                                    <td class="text-center">{{ proposal.type_sale }}</td>
                                                    <td class="text-center">
                                                        R${{ proposal.totalCommission | price }}
                                                        <i class="material-icons" :alt="proposal.textCommission" :title="proposal.textCommission">search</i>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>Totais ({{ proposals.length }} contrato{{ proposals.filter(proposal => proposal.totalCommission > 0).length > 1 ? 's' : '' }})</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">R$ {{ sum(proposals.filter(proposal => proposal.totalCommission > 0), 'value') | price }}</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">-</td>
                                                    <td class="text-center">R$ {{ sum(proposals.filter(proposal => proposal.totalCommission > 0), 'totalCommission') | price }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="panel panel-defaul">
                                    <div class="panel-body" style="overflow-x: auto;">
                                        <table id="tabela" class="table b-table table-sm">
                                            <thead class="thead-dark">
                                                <tr>
                                                    <th class="text-center">{{ !form.type_profile_id ? 'TODAS' : (profiles.length > 0?profiles.find(profile => profile.id === form.type_profile_id).name.toUpperCase(): 'TODAS') }}</th>
                                                    <th class="text-center">Qtd de Cotas</th>
                                                    <th class="text-center">Valor das Cotas</th>
                                                    <th class="text-center">Comissão</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(proposals, itemName) in items" :key="itemName" v-if="proposals.filter(proposal => proposal.totalCommission > 0).length > 0">
                                                    <td>{{ itemName }}</td>
                                                    <td class="text-center">{{ proposals.filter(proposal => proposal.totalCommission > 0).length }}</td>
                                                    <td class="text-center">R$ {{ sum(proposals.filter(proposal => proposal.totalCommission > 0), 'value') | price }}</td>
                                                    <td class="text-center">R$ {{ sum(proposals.filter(proposal => proposal.totalCommission > 0), 'totalCommission') | price }}</td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>Totais</td>
                                                    <td class="text-center">{{ countAllProposals(items) }}</td>
                                                    <td class="text-center">R$ {{ sumAllProposals(items, "value") | price }}</td>
                                                    <td class="text-center">R$ {{ sumAllProposals(items, "totalCommission") | price }}</td>
                                                </tr>
                                            </tfoot>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container dont-print">
            <div class="col-md-12 text-center">
                <button type="button" @click="close()" class="btn btn-fill btn-danger">Voltar</button>
                <button type="button" @click="print()" class="btn btn-fill btn-info">Imprimir</button>
                <button type="button" @click="pdf()" class="btn btn-fill btn-info">PDF</button>
                <button type="button" v-show="reportItems.length" @click="excel()" class="btn btn-fill btn-success">Excel</button>
            </div>
        </div>
    </div>
</template>
<script>
    import Vue from "vue";
    import TypeProfiles from '@/services/modules/typeprofiles.service';
    import Users from '@/services/modules/users.service';
    export default {
        computed: {
            branches() {
                return this.$store.state.defaults.branches;
            },
        },
        data() {
            return {
                administrators: [],
                date_by: null,
                form: {
                    administrator_id: null,
                    branch_id: null,
                    date_at: [],
                    type_profile_id: null,
                    user_id: null
                },
                moment: Vue.moment,
                profiles: [],
                reportItems: [],
                store_branch: null,
                users: []
            };
        },
        methods: {
            close() {
                window.opener.focus();
                window.close();
            },
            countAllProposals(items) {
                var total = 0;

                Object.entries(items).forEach(([salesman, proposals]) => {
                    total += proposals.filter(proposal => proposal.totalCommission > 0).length;
                });

                return total
            },
            sumAllProposals(items, key) {
                var total = 0;

                Object.entries(items).forEach(([salesman, proposals]) => {
                    total += this.sum(proposals.filter(proposal => proposal.totalCommission > 0), key);
                });

                return total
            },
            excel() {
                var nome = "RELATÓRIO DE TIPO DE VENDAS";
                var htmlPlanilha =
                    '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>' +
                    nome +
                    "</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><title>" +
                    nome +
                    "</title></head><body><table>" +
                    document.getElementById("tabela").innerHTML + document.getElementById("tabela2").innerHTML +
                    "</table>";
                var htmlBase64 = btoa(htmlPlanilha);
                var link = "data:application/vnd.ms-excel;base64," + htmlBase64;
                var hyperlink = document.createElement("a");
                hyperlink.download = "Relatório de Tipo de Vendas";
                hyperlink.href = link;
                hyperlink.style.display = "none";
                document.body.appendChild(hyperlink);
                hyperlink.click();
                document.body.removeChild(hyperlink);
            },
            async getDataAdministrators() {
                var self = this;
                self.$root.$emit("onLoading");
                const response = self.$store.dispatch('administrators/all');
                response.then((data) => {
                    self.administrators = data
                    self.$root.$emit("onLoading");
                    self.getDataProfiles();
                    
                });
                response.catch(() => {
                    self.$root.$emit("onLoading");
                    self.getDataProfiles();
                });
            },
            async getDataProfiles() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = TypeProfiles.all();

                response.then(function (_profiles) {
                    self.profiles = _profiles.filter(profile => profile.id !== 1);
                    self.$root.$emit("onLoading");
                    self.getDataUsers()
                });

                response.catch(function () {
                    self.$root.$emit("onLoading");
                    self.getDataUsers()
                });
            },
            async getDataReport() {
                var self = this;

                console.log(self.form);

                self.$root.$emit("onLoading");
                const response = self.$store.dispatch(
                    "reports/typeSalesByProfile",
                    self.form
                );

                response.then(function(_dataReports) {
                    console.log(_dataReports);
                    self.$root.$emit("onLoading");
                    self.reportItems = _dataReports;
                });

                response.catch(function() {
                    console.log("Failure");
                    self.$root.$emit("onLoading");
                });
            },
            async getDataUsers() {
                var self = this;

                if (self.form.type_profile_id != null) {
                    const search = {
                        params: {
                            type_profile_id: self.form.type_profile_id
                        }
                    }
                    const promise = Users.all(search)

                    promise.then((users) => {
                        self.users = users
                        self.getDataReport();
                    })

                    promise.catch((error) => {
                        console.log(error)
                        self.getDataReport();
                    })
                }
            },
            print() {
                window.print();
            },
            async pdf() {
                var self = this;

                self.$root.$emit("onLoading");

                const response = self.$store.dispatch(
                    "reports/typeSalesByProfileInPdf",
                    self.form
                )

                response.then(function(_downloadPdf) {
                    let filename = 'commissions-by-type-sales.pdf'
                    let blob = new Blob([_downloadPdf], {type: 'application/pdf'});

                    let link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename 
                    link.click();

                    self.$root.$emit("onLoading")
                });

                response.catch(function() {
                    self.$root.$emit("onLoading");
                });
            },
            sum(_proposals, _reducer) {
                var sum = 0;

                _proposals.forEach(function (_proposal) {
                    sum += parseFloat(_proposal[_reducer]);
                });

                return sum;
            },
        },
        mounted() {
            var self = this;
            var dates = [
                {id: 'sale_at', name: 'Data de Venda'},
                {id: 'pay_at', name: 'Data de Pagamento'}
            ];

            self.form = JSON.parse(self.$route.query.form);
            self.date_by = dates.find(date => date.id == self.form.date_by).name;
            self.store_branch   = self.form.branch_id ? self.branches.find(item => item.id === self.form.branch_id).name.toUpperCase() : null;
            self.getDataAdministrators();
        }
    };
</script>
<style type="scss">
    @media print {
        .dont-print {
            display: none;
        }
    }
</style>
